// import React from 'react';
// import { TextField } from '@mui/material';
// import Grid from '@mui/material/Grid2';
// import type { FormData } from '../../../types';

// interface ProductBasicInfoProps {
// 	formData: FormData;
// 	setFormData: React.Dispatch<React.SetStateAction<FormData>>;
// 	disabled?: boolean;
// }

// const ProductBasicInfo: React.FC<ProductBasicInfoProps> = ({ formData, setFormData, disabled }) => {
// 	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		const { name, value } = e.target;
// 		setFormData((prev) => ({ ...prev, [name]: value }));
// 	};

// 	return (
// 		<>
// 			<Grid size={{ xs: 12 }}>
// 				<TextField
// 					size="small"
// 					label="Product Name"
// 					name="name"
// 					variant="outlined"
// 					fullWidth
// 					value={formData.name}
// 					onChange={handleChange}
// 					required
// 					disabled={disabled}
// 					InputProps={{
// 						sx: { fontSize: { xs: 14, sm: 16, md: 18 } }, // font size for input text
// 					}}
// 				/>
// 			</Grid>
// 			<Grid size={{ xs: 12 }}>
// 				<TextField
// 					size="small"
// 					name="slug"
// 					label="URL Name"
// 					variant="outlined"
// 					fullWidth
// 					value={formData.slug}
// 					disabled={disabled}
// 					onChange={(e) => {
// 						const formattedValue =
// 							formData.name ||
// 							e.target.value
// 								.toLowerCase()
// 								.replace(/\s+/g, '-')
// 								.replace(/[^a-z_-]/g, '');
// 						setFormData((prev) => ({ ...prev, slug: formattedValue }));
// 					}}
// 					onPaste={(e) => {
// 						e.preventDefault();
// 						const pastedData = e.clipboardData
// 							.getData('text/plain')
// 							.toLowerCase()
// 							.replace(/\s+/g, '_')
// 							.replace(/[^a-z_-]/g, '');
// 						setFormData((prev) => ({ ...prev, slug: pastedData }));
// 					}}
// 					required
// 					inputProps={{
// 						pattern: '[a-z_-]+',
// 						title: 'Only lowercase letters, hyphens, and underscores are allowed',
// 					}}
// 					InputProps={{
// 						sx: { fontSize: { xs: 14, sm: 16, md: 18 } }, // font size for input text
// 					}}
// 				/>
// 			</Grid>
// 		</>
// 	);
// };

// export default ProductBasicInfo;
import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import type { FormData } from '../../../types';

interface ProductBasicInfoProps {
	formData: FormData;
	setFormData: React.Dispatch<React.SetStateAction<FormData>>;
	disabled?: boolean;
}

const ProductBasicInfo: React.FC<ProductBasicInfoProps> = ({ formData, setFormData, disabled }) => {
	const [isSlugEdited, setIsSlugEdited] = useState(false);

	// Auto-generate slug from product name (only if slug hasn't been manually edited)
	useEffect(() => {
		if (!isSlugEdited && formData.name) {
			const generatedSlug = formData.name
				.toLowerCase()
				.replace(/\s+/g, '-')
				.replace(/[^a-z0-9_-]/g, '');
			setFormData((prev) => ({ ...prev, slug: generatedSlug }));
		}
	}, [formData.name, isSlugEdited, setFormData]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSlugChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setIsSlugEdited(true);
		const formattedValue = e.target.value
			.toLowerCase()
			.replace(/\s+/g, '-')
			.replace(/[^a-z0-9_-]/g, '');
		setFormData((prev) => ({ ...prev, slug: formattedValue }));
	};

	return (
		<>
			<Grid size={{ xs: 12 }}>
				<TextField
					size="small"
					label="Product Name"
					name="name"
					variant="outlined"
					fullWidth
					value={formData.name}
					onChange={handleChange}
					required
					disabled={disabled}
					InputProps={{
						sx: { fontSize: { xs: 14, sm: 16, md: 18 } },
					}}
				/>
			</Grid>
			<Grid size={{ xs: 12 }}>
				<TextField
					size="small"
					name="slug"
					label="URL Name"
					variant="outlined"
					fullWidth
					value={formData.slug}
					disabled={disabled}
					onChange={handleSlugChange}
					onPaste={(e) => {
						e.preventDefault();
						setIsSlugEdited(true);
						const pastedData = e.clipboardData
							.getData('text/plain')
							.toLowerCase()
							.replace(/\s+/g, '-')
							.replace(/[^a-z0-9_-]/g, '');
						setFormData((prev) => ({ ...prev, slug: pastedData }));
					}}
					required
					inputProps={{
						pattern: '[a-z0-9_-]+',
						title: 'Only lowercase letters, numbers, hyphens, and underscores are allowed',
					}}
					InputProps={{
						sx: { fontSize: { xs: 14, sm: 16, md: 18 } },
					}}
				/>
			</Grid>
		</>
	);
};

export default ProductBasicInfo;
